import { Checkbox } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { ComboBoxBatiment } from '../../ComboBox/ComboBoxBatiment';
import { ComboBoxCycleReservation } from '../../ComboBox/ComboBoxCycleReservation';
import { ComboBoxEcheancier } from '../../ComboBox/ComboBoxEcheancier';
import { ComboBoxEtage } from '../../ComboBox/ComboBoxEtage';
import { ComboBoxLotType } from '../../ComboBox/ComboBoxLotType';
import { ComboBoxOperation_Stade } from '../../ComboBox/ComboBoxOperation_Stade';
import { ComboBoxTVA } from '../../ComboBox/ComboBoxTVA';
//import { ComboBoxTVATaux } from '../../ComboBox/ComboBoxTVATaux';
import { EUIPanel } from '../../EUI/EUIPanel';

export class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
    };

    static defaultState = {
        afficherADFNonExigibles: true,
        afficherADFEffectues: true,
        afficherReservationsIneligibles: true,
        batiment: undefined,
        etage: undefined,
        idEcheancier: undefined,
        idLotType: undefined,
        idOperation: undefined,
        idsCyclesReservations: [],
        idStadeDernierAppele: undefined,
        taux: undefined,
    };

    constructor(props) {
        super(props);
        this.state = { ...PanelFiltres.defaultState };
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _reinitialiserFiltres = () => {
        const { idOperation } = this.props.filtres;
        this.setState({
            ...PanelFiltres.defaultState,
            idOperation,
        });
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { afficherADFNonExigibles, afficherADFEffectues, afficherReservationsEligibles, afficherReservationsIneligibles, batiment, etage, idEcheancier, idLotType, idOperation, idsCyclesReservations, idStadeDernierAppele, taux } = this.state;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >
            <ComboBoxEcheancier
                avecValeurDefaut={false}
                disabled={!idOperation} // Désactivé tant qu'on ne sélectionne pas une opération dans le périmètre
                idOperation={idOperation}
                onChange={(event, option, index, value, item) => this.setState({ idEcheancier: item.idEcheancier })}
                selectedKey={idEcheancier}
            />

            <ComboBoxOperation_Stade
                avecValeurDefaut={false}
                disabled={!idOperation} // Désactivé tant qu'on ne sélectionne pas une opération dans le périmètre
                idOperation={idOperation}
                label="Dernier stade appelé"
                onChange={(event, option, index, value, item) => this.setState({ idStadeDernierAppele: item.idStade })}
                selectedKey={idStadeDernierAppele}
            />

            <ComboBoxCycleReservation
                avecValeurDefaut={false}
                multiSelect
                onChange={(event, option, _, value, item) => {
                    const index = idsCyclesReservations.indexOf(option.key);

                    let newIdsCyclesReservations = [...idsCyclesReservations];
                    if (option.selected && index === -1)
                        newIdsCyclesReservations.push(option.key);
                    else newIdsCyclesReservations.splice(index, 1);

                    this.setState({ idsCyclesReservations: newIdsCyclesReservations })
                }}
                selectedKey={idsCyclesReservations}
            />

            <ComboBoxTVA
                avecValeurDefaut={false}
                idOperation={idOperation}
                onChange={(event, option, index, value, item) => this.setState({ taux: option.key })}
                selectedKey={taux}
            />

            <ComboBoxBatiment
                avecValeurDefaut={false}
                idOperation={idOperation}
                onChange={(event, option, index, value, item) => this.setState({ batiment: item })}
                selectedKey={batiment}
            />

            <ComboBoxEtage
                avecValeurDefaut={false}
                idOperation={idOperation}
                onChange={(event, option, index, value, item) => this.setState({ etage: item })}
                selectedKey={etage}
            />

            <ComboBoxLotType
                avecValeurDefaut={false}
                idOperation={idOperation}
                onChange={(event, option, index, value, item) => this.setState({ idLotType: item.idLotType })}
                selectedKey={idLotType}
            />

            <Checkbox
                checked={!(afficherADFNonExigibles && afficherADFEffectues)}
                label="ADF exigibles non effectués uniquement"
                onChange={(e, isChecked) => this.setState({
                    afficherADFEffectues: !isChecked,
                    afficherADFNonExigibles: !isChecked,
                    afficherReservationsIneligibles: false,
                })}
                styles={{ root: { marginTop: "8px" } }}
            />

            <Checkbox
                checked={afficherReservationsIneligibles}
                disabled={!afficherADFNonExigibles}
                label="Afficher réservations inéligibles"
                onChange={(e, isChecked) => this.setState({ afficherReservationsIneligibles: isChecked })}
            />
        </EUIPanel>;

    };

};